package com.schoolconnect.app.feature.timetable

data class TeacherTimeTableClassOption(
    val id: String,
    val className: String,
    val sectionName: String
) {
    val label: String get() = listOf(className, sectionName).filter(String::isNotBlank).joinToString("-")
}

data class TeacherTimeTableUiState(
    val classes: List<TeacherTimeTableClassOption> = emptyList(),
    val selectedClassId: String = "",
    val weekly: ParentTimeTableGridUi = ParentTimeTableGridUi(),
    val special: ParentTimeTableGridUi = ParentTimeTableGridUi(),
    val weekLabel: String? = null,
    val specialScheduleLabel: String = "—",
    val weeklyOffLabel: String = "—",
    val lastUpdatedLabel: String? = null,
    val isLoadingClasses: Boolean = true,
    val isLoadingSchedule: Boolean = false,
    val hasPublishedTimetable: Boolean? = null,
    val errorMessage: String? = null
) {
    val selectedClass: TeacherTimeTableClassOption? get() = classes.firstOrNull { it.id == selectedClassId }
}

sealed interface TeacherTimeTableUiEvent {
    data class ClassSelected(val classSectionId: String) : TeacherTimeTableUiEvent
    data object Retry : TeacherTimeTableUiEvent
}
